import { Component, OnInit, ViewChild } from "@angular/core";
import { LeadsService } from "../../../services/lead-service/lead-service.service";

@Component({
  selector: "app-lead-export-logs-modal",
  templateUrl: "./lead-export-logs-modal.component.html",
  styleUrls: ["./lead-export-logs-modal.component.css"],
})
export class LeadExportLogsModalComponent implements OnInit {
  @ViewChild("exportModal") exportModal: any;

  logs: any[] = [];
  isLoading: boolean = false;
  hasError: boolean = false;
  errorMessage: string = "";
  searchTerm: string = "";
  pagination: any = null;

  constructor(private leadsService: LeadsService) {}

  ngOnInit() {}

  open() {
    if (this.exportModal) {
      this.exportModal.open();
    }
    this.searchTerm = "";
    this.loadLogs(1);
  }

  close() {
    if (this.exportModal) {
      this.exportModal.close();
    }
  }

  loadLogs(page: number = 1) {
    this.isLoading = true;
    this.hasError = false;
    this.errorMessage = "";
    this.leadsService.getLeadExportLogs(page).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.handleResponse(res);
      },
      (err: any) => {
        this.isLoading = false;
        this.hasError = true;
        this.errorMessage =
          err && err.error && err.error.message
            ? err.error.message
            : "Failed to load lead export logs. Please try again.";
        console.error("Error fetching lead export logs:", err);
      }
    );
  }

  loadUrl(url: string) {
    if (!url) return;
    this.isLoading = true;
    this.hasError = false;
    this.errorMessage = "";
    this.leadsService.getLeadExportLogs(url).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.handleResponse(res);
      },
      (err: any) => {
        this.isLoading = false;
        this.hasError = true;
        this.errorMessage = "Failed to load lead export logs.";
        console.error("Error fetching lead export logs:", err);
      }
    );
  }

  handleResponse(res: any) {
    if (Array.isArray(res)) {
      this.logs = res;
      this.pagination = null;
    } else if (res && Array.isArray(res.data)) {
      this.logs = res.data;
      this.pagination = {
        currentPage: res.current_page || 1,
        lastPage: res.last_page || 1,
        total: res.total !== undefined ? res.total : res.data.length,
        from: res.from || 1,
        to: res.to || res.data.length,
        nextPageUrl: res.next_page_url,
        prevPageUrl: res.prev_page_url,
      };
    } else if (res && res.logs && Array.isArray(res.logs)) {
      this.logs = res.logs;
      this.pagination = null;
    } else {
      this.logs = [];
      this.pagination = null;
    }
  }

  get filteredLogs(): any[] {
    if (!this.searchTerm || !this.searchTerm.trim()) {
      return this.logs;
    }
    const term = this.searchTerm.toLowerCase().trim();
    return this.logs.filter((log: any) => {
      const userName = (
        (log && log.user && log.user.name) ||
        (log && log.user_name) ||
        ""
      ).toLowerCase();
      const userEmail = (
        (log && log.user && log.user.email) ||
        (log && log.email) ||
        ""
      ).toLowerCase();
      const dateStr = (
        (log && (log.Created_at || log.created_at)) ||
        ""
      )
        .toString()
        .toLowerCase();
      return (
        userName.includes(term) ||
        userEmail.includes(term) ||
        dateStr.includes(term)
      );
    });
  }

  onPrevPage() {
    if (!this.pagination) return;
    if (this.pagination.prevPageUrl) {
      this.loadUrl(this.pagination.prevPageUrl);
    } else if (this.pagination.currentPage > 1) {
      this.loadLogs(this.pagination.currentPage - 1);
    }
  }

  onNextPage() {
    if (!this.pagination) return;
    if (this.pagination.nextPageUrl) {
      this.loadUrl(this.pagination.nextPageUrl);
    } else if (this.pagination.currentPage < this.pagination.lastPage) {
      this.loadLogs(this.pagination.currentPage + 1);
    }
  }

  getLogUserName(log: any): string {
    return (
      (log && log.user_name) ||
      (log && log.user && log.user.name) ||
      "-"
    );
  }

  getLogEmail(log: any): string {
    return (
      (log && log.user_email) ||
      (log && log.user && log.user.email) ||
      ""
    );
  }

  getLogDate(log: any): any {
    return log && (log.created_at || log.Created_at || log.completed_at);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/lead-export-logs-modal/lead-export-logs-modal.component.ts